import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IGetCategoryParamsType, IGetUserCategoryResponseType } from './type'
import { IResponseType } from '@/types/response-type'

export function useGetUserCategory({
  disableToast,
  ...rest
}: IApiBaseTypes<IGetCategoryParamsType> = {}) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IGetUserCategoryResponseType>({
        url: 'mrf/categories-register/',
        method: 'get'
      }),
    queryKey: ['userCategoryList'],
    retry: 0,
    select: (data) => data?.data,
    ...rest
  })
}
